import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';
import * as Sentry from '@sentry/browser';
import createSentryMiddleware from 'redux-sentry-middleware';

import { reducers as coreReducer } from '$data/core';
import { reducers as assessmentItemsReducer } from '$data/assessmentItems';
import { reducers as assignmentsReducer } from '$data/assignments';
import { reducers as participantsReducer } from '$data/participants';
import { reducers as providersReducer } from '$data/providers';

const rootReducer = combineReducers({
  core: coreReducer,
  assessmentItems: assessmentItemsReducer,
  assignments: assignmentsReducer,
  participants: participantsReducer,
  providers: providersReducer,
});

const configureStore = () => {
  const enhancer =
    process.env.NODE_ENV === 'development'
      ? composeWithDevTools(
          applyMiddleware(
            thunk,
            createLogger({ level: 'info', collapsed: true })
          )
        )
      : applyMiddleware(thunk, createSentryMiddleware(Sentry, {}));

  return createStore(rootReducer, {}, enhancer);
};

export default configureStore;
